'use client';
import ZaloIcon from '@public/icons/icon-zalo.svg';
import { zaloLink } from 'lib/constants';
import FloatingIcon from 'components/common/FloatingIcon';
import { useScrollVisibility } from 'hooks/useScrollVisibility';

interface ZaloWidgetProps {
  locale?: string;
}

function ZaloWidget({ locale }: Readonly<ZaloWidgetProps>) {
  const isVisible = useScrollVisibility();

  if (locale !== 'vi') return null;
  return (
    <FloatingIcon
      isVisible={isVisible}
      link={zaloLink}
      icon={ZaloIcon}
      dataTestId="zalo-widget-container"
    />
  );
}

export default ZaloWidget;
